import axios from 'axios'

export function searchFortnoxCustomers(integrationId, searchTerm) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/fetch-customers-fortnox?keyword=' + searchTerm, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function createFortnoxCustomer(integrationId, data) {
    return axios.post(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/create-customer-fortnox', data, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}
export function authorizeFortnox(integrationId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/authorize-fortnox', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function setFortnoxAuthToken(integrationId, code) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/fortnox-authenticate?code=' + code, {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}

export function getFortnoxIntegration(spaceId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/spaces/' + spaceId + '/integrations?filter[name]=fortnox', {
        headers: {
            'Content-Type': 'application/vnd.api+json'
        },
    })
}

export function fetchFortnoxCompany(integrationId) {
    return axios.get(process.env.VUE_APP_API_BASE_URL + '/' + process.env.VUE_APP_API_VERSION + '/integrations/' + integrationId + '/-actions/fetch-company-fortnox', {
        headers: {
            'Content-Type': 'application/vnd.api+json',
        },
    })
}